import axios from 'axios';
import { SYMFONY_API_BASE_URL } from '@config/apiConfig';
const resendConfirmEmail = () => axios.post(`${SYMFONY_API_BASE_URL}/resend_confirm_email`);
export default resendConfirmEmail;
